export { default } from './Container';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Container/index.js
// module id = 819
// module chunks = 2